import { Backdrop, Box, CircularProgress, Typography } from '@mui/material';
import { useRecoilValue } from 'recoil';
import { loadingOverlayState } from '~/state/atoms/viewerAtoms';

export default function LoadingOverlay() {
    const { isOpen, message } = useRecoilValue(loadingOverlayState);
    return (
        isOpen && (
            <Box
                position="absolute"
                overflow="hidden"
                top={0}
                left={0}
                zIndex={4000}
                width="100vw"
                height="100vh"
            >
                <Backdrop open={true} style={{ zIndex: 1300 }}>
                    <Box
                        p={2}
                        width={300}
                        borderRadius={1}
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        justifyContent="center"
                        bgcolor={(theme) => theme.palette.background.paper}
                    >
                        <CircularProgress size={24} />
                        <Typography mt={2}>{message}</Typography>
                    </Box>
                </Backdrop>
            </Box>
        )
    );
}
